import React from 'react';
import queryString from 'query-string';

const ITEMS_PER_PAGE = 30

function paginationVariables(props){
  let first = props.first ? parseInt(props.first, 10) : undefined
  const last = props.last ? parseInt(props.last, 10) : undefined
  if(!first && !last){
    first = ITEMS_PER_PAGE
  }
  const {
    after,
    before
  } = props
  return {
    first,
    last,
    after,
    before
  }
}


function withPagination(initialFilters, initialOrder){
  return (WrappedComponent) => {
    return (props) => {
      const {after, before, first, last, orderBy, ...filters} = queryString.parse(props.history.location.search, {arrayFormat: 'bracket'})
      return <WrappedComponent
          filter = {
            {
              ...initialFilters,
              ...filters
            }
          }
          orderBy = { orderBy || initialOrder }
          after = { after }
          before = { before }
          first = { first }
          last = { last }
          {...props}
        />
    }
  }
}

export {paginationVariables, withPagination, ITEMS_PER_PAGE}



// WEBPACK FOOTER //
// ./src/utils/pagination.js